import React from 'react';
import { Helmet } from 'react-helmet-async';
import SupportForm from '../components/SupportForm';

const SupportPage = () => {
  return (
    <div className="min-h-[calc(100vh-64px)] bg-gray-50 p-4 sm:p-6">
      <Helmet>
        <title>Support - SwiftBidPro</title>
        <meta name="description" content="Get help with SwiftBidPro. Report bugs, request features, or contact our support team for assistance." />
      </Helmet>

      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Support Center
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're here to help! Report bugs, suggest features, or get support with your account.
          </p>
        </div>

        <SupportForm />

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            We typically respond within 24 hours during business days.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;